export default __webpack_public_path__ + "static/media/kitchen.165f3880.svg";